import React from 'react'
const IconProducts2 = ({ width = 32, height = 32 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width={width}
    height={height}
    viewBox='0 0 32 32'
  >
    <defs>
      <clipPath id='master_svg0_70_5736'>
        <rect x='0' y='0' width='32' height='32' rx='0' />
      </clipPath>
      <linearGradient x1='0.5' y1='0' x2='0.5' y2='1' id='master_svg1_1_00183'>
        <stop offset='0%' stopColor='#D8D8D8' stopOpacity='0' />
        <stop offset='100%' stopColor='#FFFFFF' stopOpacity='1' />
      </linearGradient>
    </defs>
    <g clipPath='url(#master_svg0_70_5736)'>
      <g>
        <rect x='0' y='0' width='32' height='32' rx='2.133' fill='#FD5C1F' fillOpacity='1' />
      </g>
      <g>
        <g>
          <g>
            <ellipse cx='16.267' cy='16.267' rx='5.067' ry='5.067' fill='url(#master_svg1_1_00183)' fillOpacity='1' />
          </g>
          <g>
            <path
              d='M25.271,10.624Q25.269,9.984,24.708,9.675L16.525,5.166Q16,4.877,15.475,5.166L7.292,9.675Q6.731,9.984,6.729,10.624Q6.726,11.265,7.285,11.577L15.468,16.161Q16,16.458,16.532,16.161L24.715,11.577Q25.274,11.265,25.271,10.624ZM16.139,5.867L24.322,10.376Q24.471,10.458,24.471,10.627Q24.472,10.797,24.324,10.879L16.141,15.463Q16,15.542,15.859,15.463L7.676,10.879Q7.528,10.797,7.529,10.627Q7.529,10.458,7.678,10.376L15.861,5.867Q16,5.79,16.139,5.867Z'
              fillRule='evenodd'
              fill='#FFFFFF'
              fillOpacity='1'
            />
          </g>
          <g>
            <path
              d='M25.29,20.849V10.84H24.49V20.849Q24.49,21.01,24.353,21.094L16.447,25.952V15.868H15.647V25.944L7.513,20.84V10.84H6.713V21.283L16.045,27.138L24.772,21.776Q25.29,21.457,25.29,20.849Z'
              fillRule='evenodd'
              fill='#FFFFFF'
              fillOpacity='1'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default IconProducts2
